// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-tips[data-v-56fd05cc]{color:red;max-width:13.541667rem;position:absolute}", ""]);
// Exports
module.exports = exports;
